<template>
  <router-view/>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';

@Component
export default class Completion extends Vue {

}
</script>
